/* eslint-disable import/prefer-default-export */
import { useInfiniteQuery } from '@tanstack/react-query';
import axios from 'axios';

import { type User } from '@app/types/api/user';

import { QUERY_KEYS } from './constants';
import { buildPaginatedQueryString } from './helpers';
import { GET_USERS } from '../constants/endpoints';
import { getAccessToken } from '../helpers/localStorage';
import { IN_TESTING_MODE, TEST_AUTH_TOKEN } from '../tests/constants';

export function useOperatorsQuery(customFilters: { searchText?: string; ids?: string[] }) {
  const filters = {
    ...customFilters,
    limit: 32,
    role: 'operator',
    active: true,
    sort: 'profile.firstName',
    order: 'ASC',
  };
  async function fetchOperators({ pageParam = 1 }) {
    if (filters.ids && !filters.ids.length) {
      return { operators: [] };
    }
    const filterQueryString = buildPaginatedQueryString(pageParam, filters);
    const url = `${GET_USERS}${
      filterQueryString ? `?${filterQueryString}` : ''
    }`;

    const token = IN_TESTING_MODE ? TEST_AUTH_TOKEN : await getAccessToken();

    return axios({
      url,
      method: 'GET',
      headers: { Authorization: token },
    }).then((response) => ({
      operators: response.data.users.map((operator: User) => ({
        ...operator,
        id: operator._id,
        name: `${operator?.profile?.firstName} ${operator?.profile?.lastName}`,
        imageUrl: operator?.profile?.imageUrl,
      })),
    }));
  }

  return useInfiniteQuery([QUERY_KEYS.OPERATORS, filters], fetchOperators, {
    getNextPageParam: (lastPage, pages) => {
      if ((lastPage?.operators?.length || 0) < filters.limit) return undefined;
      return (pages?.length || 0) + 1;
    },
  });
}
